/* ==================================================================
   Public legal pages (/privacy, /delete-account)
   ------------------------------------------------------------------
   PLACEHOLDERS — confirm every value below before deploying.
   They are referenced by both pages and by the store listings
   (Google Play data-safety form, App Store privacy URL).
   ================================================================== */

// Inbox that receives privacy questions and deletion requests
// (confirmed: the existing support mailbox).
export const PRIVACY_EMAIL = "support@nexploy-eg.com";

// TODO(confirm): registered legal name of the company that operates Nexploy.
export const COMPANY_LEGAL_NAME = {
  en: "Nexploy",
  ar: "Nexploy",
};

// TODO(confirm): date this policy takes effect (shown as "Last updated").
export const POLICY_EFFECTIVE_DATE = "2026-10-23";

// TODO(confirm): how long encrypted backups keep deleted data before it
// is overwritten, in days.
export const BACKUP_PURGE_DAYS = 90;

// Deletion requests are completed within this many days of verification.
export const DELETION_DAYS = 30;
